<template>
  <div class="flex items-center justify-between mt-8 space-x-2">
    <button
      @click="$emit('prev')"
      :disabled="currentPage === 1"
      class="px-3 sm:px-4 py-2 rounded-lg border border-brd-primary-color bg-ds-button-color text-btn-txt-color hover:bg-header-hover-color font-medium text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Prev Page
    </button>
    <span
      class="px-3 sm:px-4 py-2 text-sm sm:text-base font-semibold text-txt-primary-color bg-gray-50 rounded-lg border border-brd-primary-color"
    >
      {{ currentPage }} / {{ totalPages }}
    </span>
    <button
      v-if="currentPage < totalPages"
      @click="$emit('next')"
      class="px-3 sm:px-4 py-2 rounded-lg border border-brd-primary-color bg-ds-button-color text-btn-txt-color hover:bg-header-hover-color font-medium text-sm sm:text-base"
    >
      Next Page
    </button>
    <button
      v-else
      @click="$emit('submit')"
      class="px-3 sm:px-4 py-2 rounded-lg border border-green-600 bg-green-600 text-white hover:bg-green-700 font-medium text-sm sm:text-base"
    >
      Submit
    </button>
  </div>
</template>

<script>
export default {
  name: "HeroPagination",
  props: {
    currentPage: { type: Number, default: 1 },
    totalPages: { type: Number, required: true },
  },
  emits: ["prev", "next", "submit"],
};
</script>
